import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, startGoogleLogin } from "../../context/AuthContext";
import { BagLogo } from "../../components/Logo";

/** Ponesi Partner entry for partner.ponesi.rs. Presentation layer ONLY — it reuses the existing
 * identity/auth backend, creates no users and no separate session store. There is deliberately no
 * public self-registration: restaurant access is invite/approval based (membership granted
 * server-side). Authorization (active membership + STAFF/MANAGER/OWNER) is verified by the backend
 * after login, in RestaurantEntry. */
export default function PartnerLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (!loading && user) navigate("/restaurant", { replace: true }); }, [user, loading, navigate]);

  return (
    <div className="min-h-dvh flex items-center justify-center p-6 bg-[#0F1115]" data-testid="partner-login">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="flex justify-center"><BagLogo size={56} /></div>
          <h1 className="font-display font-black text-3xl text-center mt-5">
            Ponesi <span className="text-brand-red">Partner</span>
          </h1>
          <p className="text-sm text-slate-500 text-center mt-2">Prijavite se za upravljanje restoranom.</p>
          <button data-testid="partner-google-login" onClick={() => startGoogleLogin("/restaurant")}
            className="w-full mt-7 min-h-[52px] bg-brand-red hover:bg-brand-redHover text-white rounded-full font-display font-bold shadow-lg active:scale-[0.98] transition-transform">
            Prijavi se
          </button>
          <p className="text-[11px] leading-relaxed text-slate-400 text-center mt-5">
            Pristup panelu dobijaju samo pozvani članovi tima restorana. Ako ste restoran koji želi da
            se pridruži Ponesi platformi, prijavu pošaljite na <span className="font-semibold">ponesi.rs/b2b</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
